import React, {useEffect, useRef, useState} from 'react'
import {Link, useLocation, useNavigate, useSearchParams,} from 'react-router-dom'
import Tabbar from '../../components/Tabbar'
import Profile from '../../components/Profile'
import Search from '../../components/Search'
import '../../styles/css/Karyawan.css'
import '../../styles/css/JadwalGuru.css'
import searchIcon from '../../assets/icons/search-icon.svg'
import {useDispatch, useSelector} from 'react-redux'
import Sidebar from '../../components/sidebar/Sidebar'
import {getKategori, setCurrentKategori, setIsInitial, setKategoriId} from '../../features/ketegoriSlice'
import Skeleton from 'react-loading-skeleton'

import {getJadwalGuru, importJadwal, resetTable, updateStateJadwalGuru} from "../../features/jadwalGuruSlice";
import {updateStateSiswa} from "../../features/siswaSlice";
import LoadingTable from "../../components/LoadingTable";
import DisplayKategoriList from "../../components/DisplayKategoriList";
import imgErrorValidation from "../../utils/imgErrorValidation";
import Button from "../../components/Button";
import {updateStateWaliKelas} from "../../features/waliKelasSlice";


const GREY = '#9B9B9B'
const BORDER = '#ECEEF2'

function JadwalGuru() {


    let kategoriAll = [
        {id: 'all', kategori: 'Semua Guru'},
    ]


    const days = ['Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu', 'Minggu']


    const {
        listJadwalGuru,
        isLoading,
        search
    } = useSelector(state => state.jadwalGuruSlice)

    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()


    const inputFileRef = useRef(null)
    const [showModal, setShowModal] = useState(false)
    const [file, setFile] = useState(null)



    useEffect(() => {
        dispatch(resetTable())
    }, [dispatch]);

    useEffect(() => {
        if (searchParams.get('paginate')) {
            dispatch(updateStateJadwalGuru({name: 'currentPage', value: parseInt(searchParams.get('paginate'))}));
        }
    }, [location.pathname, navigate, searchParams]);

    useEffect(() => {
        if (searchParams.get('search')) {
            dispatch(updateStateJadwalGuru({name: 'search', value: searchParams.get('search')}));
            dispatch(getJadwalGuru({search: searchParams.get('search')}))
        }
    }, [])


    useEffect(() => {
        dispatch(getJadwalGuru({}))
    }, []);


    useEffect(() => {
        dispatch(updateStateJadwalGuru({name: 'currentPage', value: 1}))
    }, [location.pathname.split('/').pop()]);


    function handleChange(e) {
        e.preventDefault();
        setShowModal(true)
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    }

    function handleImport() {
        dispatch(importJadwal(file))
            .then((res) => {
                if (res.meta.requestStatus === "fulfilled") {
                    setShowModal(false)
                    dispatch(getJadwalGuru({}))
                    inputFileRef.current.value = '';
                }
            })
    }

    function handleSearch() {
        dispatch(getJadwalGuru({search}))
        dispatch(updateStateJadwalGuru({name: 'currentPage', value: 1}))
        setSearchParams({
            'search': search
        })
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            handleSearch();
        }
    }



    return (
        <div className='wrapper-karyawan'>
            <Sidebar/>
            <div className='karyawan'>



                <div className='search-and-profile'>

                    <div className={'wrap-search'}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 300, marginRight: 16 }}>
                            <span style={{ color: GREY, fontSize: 14 }}>🔍</span>
                            <input
                                type="text"
                                placeholder="Cari guru"
                                value={search}
                                onKeyDown={handleKeyDown}
                                onChange={(e) => dispatch(updateStateJadwalGuru({ name: 'search', value: e.target.value }))}
                                style={{ border: 'none', outline: 'none', fontSize: 14, color: '#A6A6A6', flex: 1 }}
                            />
                        </div>



                        <button
                            className='btn-search'
                            style={{ background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 48 }}
                            onClick={handleSearch}
                        >
                            <img src={searchIcon} alt="" />
                        </button>
                    </div>
                    <Profile />
                </div>


                <div className='title-btn'>
                    <h1>Jadwal Guru</h1>
                    <div style={{display: 'flex', flexDirection: 'row', gap: '10px'}}>

                        <div className='right-header'>
                            <Button
                                style={{
                                    width: "150px",
                                    height: "45px"
                                }}
                                text={'Import Jadwal'}
                                onClick={() => inputFileRef.current.click()}
                            />
                            <input
                                style={{display: 'none'}}
                                ref={inputFileRef}
                                type="file"
                                onChange={handleChange}
                                accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
                            />
                        </div>

                    </div>
                </div>

                <div className='tabbar-filter'>
                    <Tabbar
                        options={[...kategoriAll]}
                        setKategoriId={setKategoriId}
                        setCurrentKategori={setCurrentKategori}
                        searchParams={''}
                        setKeterangan={updateStateSiswa}
                        path='/karyawan'
                        sttic={true}

                    />

                    <div className='filter-angka'>
                        {isLoading
                            ? <Skeleton
                                width={100}
                                height={25}
                            />
                            : <p>{listJadwalGuru.users.length + ' Guru'}</p>
                        }
                    </div>
                </div>

                {showModal &&
                    <div className='bg-modal'>
                        <div className='alert-modal'>
                            <h1>Import Jadwal</h1>
                            <p>Apakah anda yakin ?, ini akan menghapus jadwal guru lama</p>
                            <div>
                                <button onClick={() => setShowModal(false)}>Tidak</button>
                                <button onClick={handleImport}>Iya</button>
                            </div>
                        </div>
                    </div>
                }


                {(isLoading) ?
                    <LoadingTable size={'large'}/>
                    : <div className='schedule-container'>

                        <div
                            className='schedule-grid'
                            style={{'--teacher-count': listJadwalGuru.users.length}}
                        >
                            {/* Header kosong untuk kolom guru */}
                            <div className='teacher-header'>
                                <div className='schedule-header'>
                                    <h2>Mingguan</h2>
                                </div>
                            </div>

                            {/* Days Header */}
                            <div className='days-header'>
                                {days.map((day) => (
                                    <div key={day} className='day-header'>
                                        {day}
                                    </div>
                                ))}
                            </div>

                            {/* Teacher list & schedule rows */}
                            {listJadwalGuru.users.map((teacher) => (
                                <React.Fragment key={teacher.id}>
                                    {/* Teacher Column */}
                                    <div className='teacher-item'>
                                        <div className='teacher-avatar'>
                                            <img src={teacher?.link_foto} onError={imgErrorValidation} alt=""/>
                                        </div>
                                        <div className='teacher-info'>
                                            <div className='teacher-name'>{teacher.nama}</div>
                                            <div className='teacher-role'>{<DisplayKategoriList
                                                list={teacher.ktg_karyawan}/>}</div>
                                        </div>
                                    </div>

                                    {/* Schedule Row */}
                                    <div className='schedule-row'>

                                        {days.map((day) => {
                                            const schedules = listJadwalGuru.jadwal.filter(
                                                (s) => s.user_id === teacher.id && s.hari === day
                                            );

                                            return (
                                                <div key={`${teacher.id}-${day}`} className='schedule-cell'
                                                     style={{position: 'relative'}}>
                                                    {schedules.map((schedule, index) => {
                                                        const colors = ['#FFEEBF', '#F1E2EE', '#D6E0CB', '#BFD4EB', '#FFDDE2'];
                                                        const randomColor = colors[Math.floor(Math.random() * colors.length)];

                                                        return (
                                                            <div
                                                                key={index}
                                                                className='schedule-block'
                                                                style={{
                                                                    backgroundColor: randomColor,
                                                                    position: 'relative',
                                                                    marginTop: index > 0 ? '8px' : '0', // kasih jarak antar jadwal
                                                                }}
                                                            >
                                                                <div className='class-name'>{schedule.kelas}</div>
                                                                <div className='subject'>{schedule.subject}</div>
                                                                <div className='time'>{`${schedule.jam}`}</div>
                                                                <div className='schedule-icon'>⧉</div>
                                                            </div>
                                                        )

                                                    })}
                                                </div>
                                            );
                                        })}


                                    </div>

                                </React.Fragment>
                            ))}
                        </div>


                    </div>
                }


            </div>
        </div>
    )
}

export default JadwalGuru